<template>
  <div class="gy-login" :style="{ backgroundImage: 'url(' + require('@/assets/bg.jpg') + ')' }">
    <div class="gy-login-box" style="position: relative;">
      <div class="gy-login-title">
        <div class="logo">
          <img :src="require('@/assets/flogo.jpg')" alt="logo" />
        </div>
      </div>
    <el-form ref="form" :rules="rules" :model="form">
      <input type="password" hidden autocomplete="new-password" />
      <el-form-item prop="mobile">
        <el-input
          maxlength="11"
          placeholder="请输入手机号"
          prefix-icon="el-icon-mobile-phone"
          v-model="form.mobile"
        />
      </el-form-item>

      <el-form-item prop="code">
        <el-row :gutter="15" style="width:100%">
          <el-col :span="16">
            <el-input
              type="text"
              placeholder="请输入验证码"
              prefix-icon="el-icon-lock"
              v-model="form.code"
            />
          </el-col>
          <el-col :span="8">
            <el-button @click="sendCode" :disabled="!!time || !form.mobile">
              <span v-if="!!!time">发送验证码</span>
              <span v-else>{{ time }}s重新发送</span>
            </el-button>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item prop="alignPassword">
        <el-input
          type="password"
          placeholder="请输入密码"
          prefix-icon="el-icon-lock"
          v-model="form.alignPassword"
        />
      </el-form-item>

      <el-form-item prop="password">
        <el-input
          type="password"
          placeholder="请再次输入密码"
          prefix-icon="el-icon-lock"
          v-model="form.password"
        />
      </el-form-item>

      <el-form-item>
        <el-button
          class="gy-w__full"
          type="primary"
          :loading="loading"
          @click.stop="resetPasswordSubmitForm"
          :disabled="
						!this.form.mobile ||
							!this.form.code ||
							!this.form.alignPassword ||
							!this.form.password
					"
        >
          确定
        </el-button>
      </el-form-item>
      <el-form-item>
        <div style="text-align:right">
          <el-button type="text" @click="resetPassword(false)"
          >返回登录</el-button
          >
        </div>
      </el-form-item>
    </el-form>
    </div>
  </div>
</template>

<script>
import { registerService } from "@/api";

export default {
  data() {
    let validMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      callback();
    };
    let validPass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    let validCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };

    let validAlignPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    return {
      form: {
        mobile: '',
        password: '',
        code: '',
        alignPassword: ''
      },
      rules: {
        mobile: [{ validator: validMobile, trigger: 'blur' }],
        code: [{ validator: validCode, trigger: 'blur' }],
        password: [{ validator: validPass, trigger: 'blur' }],
        alignPassword: [{ validator: validAlignPassword, trigger: 'blur' }]
      },
      loading: false,
      isResetPassword: false,
      time: 0,
      timer: null
    };
  },
  methods: {
    resetPassword() {
      this.$router.push({
        path:'/login'
      })
    },
    sendCode() {
      let data = {
        mobile: this.form.mobile,
        type: 2
      };
      registerService.sendAuthCode(data).then(() => {
        this.$message({
          message: '验证码发送成功！',
          type: 'success'
        });
        this.time = 60;
        this.timer = setInterval(() => {
          this.time -= 1;
          if (this.time <= 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      });
    },
    resetPasswordSubmitForm() {
      if (this.form.password != this.form.alignPassword) {
        this.$message({
          message: '两次密码不一致！',
          type: 'error'
        });
        return;
      }
      let data = {
        mobile: this.form.mobile,
        captcha: this.form.code,
        password: this.form.password,
        re_pass: this.form.alignPassword
      };
      registerService.resetPassword(data).then(res => {
        if (res.code != 0) {
          this.$message({
            message: res.msg,
            type: 'error'
          });
          return;
        }
        this.$message({
          message: '密码找回成功！',
          type: 'success'
        });
        this.isResetPassword = false;
        this.form.mobile = '';
        this.form.code = '';
        this.form.alignPassword = '';
        this.form.password = '';
      });
    }
  }
};
</script>

<style lang="less" scoped>
.gy-login {
  min-height: 400px;
  height: calc(100vh - 160px);
  display: flex;
  justify-content: flex-end;
  background-repeat: no-repeat;
  background-position: center center;
  background-attachment: fixed;
  background-size: cover;
  &-box {
    margin: auto;
    width: 400px;
    height: 460px;
    border: 2px solid #f4f2f3;
    background-color: white;
    align-self: center;
    padding: 20px;
  }
  &-title {
    display: flex;
    justify-content: space-between;

    img {
      width: 200px;
      align-self: center;
    }
    span.line {
      margin-right: 5px;
      color: #34b4b3;
    }
    span {
      padding-top: 10px;
    }
  }
  &-from {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
  }
  &-input {
    box-sizing: border-box;
    width: 90%;
    line-height: 1.8;
    font-size: 20px;
    padding: 0 20px;
    border: 2px solid #cfcfcf;
    outline: none;
    margin: 10px;
  }

  &-button {
    margin: 40px 10px 10px 10px;
    width: 360px;
    font-size: 20px;
    padding: 5px 0;
    color: white;
    background-color: #35a8a4;
    border: none;
    outline: none;
    cursor: pointer;
  }
  &-forgot-register {
    width: 100%;
    margin: 0 20px;
    display: flex;
    justify-content: space-between;
  }
  .logo {
    display: flex;
    width: 0px;
    padding-top: 20px;
    flex: 1;
    justify-content: center;
  }
  .qrcode {
    position: relative;
    background-color: #35a8a4;
    width: 70px;
    height: 70px;
    text-align: right;
    img {
      width: 70px;
      height: 70px;
    }
    .qrcodeDiv {
      width: 0px;
      height: 0px;
      border: 35px solid #fff;
      border-top-color: transparent;
      border-right-color: transparent;
      cursor: pointer;
      position: absolute;
      top: 0px;
      right: 0px;
    }
    .iconfont {
      font-size: 26px;
      margin-right: 10px;
      margin-top: 10px;
      color: #fff;
    }
  }
  .qrcodeLogin_con {
    width: 300px;
    // height: 200px;
    margin: 0 auto;
    // padding: 20px 0px;
    box-sizing: content-box;
  }
}
</style>
